import '../../i18n/autoTranslate';
import React from 'react';
import Icon from '../../../components/AppIcon';
import SpotlightCard from '../../../components/ui/SpotlightCard';

const MetricCard = ({
  title,
  value,
  subtitle,
  change,
  changeType = 'neutral',
  icon,
  suffix = '',
  color = 'primary',
  onClick = null,
}) => {
  const palette = (() => {
    switch (color) {
      case 'accent':
        return { glow: 'bg-sky-400/12', iconText: 'text-sky-200', chip: 'border-sky-400/20 bg-sky-400/10 text-sky-100', spotlight: 'rgba(56,189,248,0.16)' };
      case 'success':
        return { glow: 'bg-emerald-400/12', iconText: 'text-emerald-200', chip: 'border-emerald-400/20 bg-emerald-400/10 text-emerald-100', spotlight: 'rgba(16,185,129,0.16)' };
      case 'warning':
        return { glow: 'bg-amber-300/12', iconText: 'text-amber-200', chip: 'border-amber-300/25 bg-amber-300/10 text-amber-100', spotlight: 'rgba(245,158,11,0.14)' };
      case 'error':
        return { glow: 'bg-rose-400/12', iconText: 'text-rose-200', chip: 'border-rose-400/20 bg-rose-400/10 text-rose-100', spotlight: 'rgba(244,63,94,0.14)' };
      default:
        return { glow: 'bg-white/10', iconText: 'text-white/80', chip: 'border-white/12 bg-white/6 text-white/80', spotlight: 'rgba(255,255,255,0.08)' };
    }
  })();

  const changeTone = (() => {
    if (changeType === 'positive') return { text: 'text-emerald-300', icon: 'TrendingUp' };
    if (changeType === 'negative') return { text: 'text-rose-300', icon: 'TrendingDown' };
    return { text: 'text-white/60', icon: 'Minus' };
  })();

  const clickable = typeof onClick === 'function';

  return (
    <SpotlightCard
      className={[
        "relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-2xl",
        "shadow-[0_18px_50px_-22px_rgba(0,0,0,0.75)] p-6",
        clickable ? "cursor-pointer" : "",
      ].join(" ")}
      spotlightColor={palette.spotlight}
      onClick={clickable ? onClick : undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      <div className="pointer-events-none absolute inset-0">
        <div className={`absolute -top-24 -left-24 h-[260px] w-[260px] rounded-full ${palette.glow} blur-[80px]`} />
        <div className="absolute inset-0 bg-[radial-gradient(900px_420px_at_55%_0%,rgba(255,255,255,0.10),transparent_60%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/10 to-black/45" />
      </div>

      <div className="relative z-10">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <div className="text-xs font-semibold tracking-wide text-white/60">{title}</div>
            <div className="mt-2 flex items-baseline gap-2">
              <div className="text-3xl font-semibold tracking-tight text-white">{value}</div>
              {suffix ? <div className="text-sm text-white/60 font-semibold">{suffix}</div> : null}
            </div>
            {subtitle ? <div className="mt-1 text-xs text-white/55">{subtitle}</div> : null}
          </div>

          <div className="flex flex-col items-end gap-2 shrink-0">
            <div className={`h-11 w-11 rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl flex items-center justify-center ${palette.iconText}`}>
              <Icon name={icon || "BarChart3"} size={18} />
            </div>

            {change != null && change !== '' ? (
              <div className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold ${palette.chip}`}>
                <Icon name={changeTone.icon} size={14} className={changeTone.text} />
                <span className={changeTone.text}>{change}</span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </SpotlightCard>
  );
};

export default MetricCard;
